export const translations = {
  tr: {
    nav: { services: "Hizmetler", why: "Neden Biz", fleet: "Filo", contact: "İletişim" },
    hero: {
      overline: "GİRNE · KKTC · 7/24",
      titleLines: ["VIP GİRNE", "TAKSİ"],
      tagline: "Ulaşımın Ötesinde.",
      desc: "Girne ve tüm Kuzey Kıbrıs'ta lüks havalimanı, otel ve casino transferi. Diskret, dakik ve kusursuz.",
      cta: "WhatsApp'tan Yaz",
      call: "Hemen Ara",
      scroll: "Kaydır",
    },
    marquee: ["Girne", "Ercan Havalimanı", "Lefkoşa", "Gazimağusa", "Kaya Artemis", "Merit Casino", "Bafra"],
    manifesto: {
      overline: "MANİFESTO",
      title: "Detaylar her şeydir.",
      chapters: [
        { num: "01", title: "Dakiklik", text: "Uçağınız iner inmez şoförünüz kapıda. Uçuşunuzu canlı takip eder, gecikmelerde bile sizi bekleriz. Zamanınız değerlidir." },
        { num: "02", title: "Diskresyon", text: "Sessiz, güvenilir ve profesyonel şoförler. Yolculuğunuz mahremdir; konforunuz ve gizliliğiniz önceliğimizdir." },
        { num: "03", title: "Filo", text: "Bakımlı Mercedes VIP araçlar, deri döşeme, klima ve ferahlık. Her transfer bir birinci sınıf deneyimdir." },
      ],
    },
    services: {
      overline: "HİZMETLER",
      title: "Her türlü transfer.",
      items: [
        { tag: "HAVALİMANI", title: "Ercan Transfer", desc: "Ercan Havalimanı'ndan otelinize, evinize veya casinoya konforlu ve dakik VIP transfer." },
        { tag: "CASINO", title: "Casino VIP", desc: "Merit, Kaya Artemis ve tüm casino otellerine özel VIP ulaşım — gece boyunca hizmetinizde." },
        { tag: "OTEL", title: "Otel Transferleri", desc: "Girne ve Kuzey Kıbrıs'taki tüm otellere kapıdan kapıya lüks transfer hizmeti." },
      ],
    },
    fleet: {
      overline: "FİLO",
      title: "Konforun sınırı yok.",
      desc: "Modern, bakımlı ve lüks araç filomuz her yolculukta size birinci sınıf konfor sunar.",
    },
    contact: {
      overline: "İLETİŞİM · 7/24 AÇIK",
      title: "Yolculuğunuz bir mesaj uzağınızda.",
      desc: "Rezervasyon ve fiyat teklifi için WhatsApp'tan yazın ya da bizi arayın. Anında yanıt veriyoruz.",
      whatsapp: "WhatsApp",
      call: "Ara",
    },
    footer: {
      tagline: "Girne / KKTC · Lüks Transfer & Ulaşım",
      rights: "Tüm hakları saklıdır.",
      by: "by Ektiren Project",
      aboutEktiren: "Ektiren Project Hakkında",
    },
    ektiren: {
      back: "Ana Sayfa",
      overline: "DİJİTAL STÜDYO",
      title: "Ektiren Project",
      lead: "Bu site bir Ektiren Project ürünüdür. Markalara sadece web sitesi değil; karakteri, hızı ve dönüşümü olan dijital deneyimler tasarlıyoruz.",
      body: "Ektiren Project; lüks, sinematik ve performans odaklı web deneyimleri üreten bir dijital tasarım ve yazılım stüdyosudur. Rakiplerinden ayrışmak isteyen markalar için özgün arayüzler, akıcı animasyonlar ve gelişmiş SEO altyapısı ile fark yaratan projeler geliştiriyoruz. VIP Girne Taksi de bu yaklaşımın bir yansımasıdır.",
      services: [
        { title: "Web Tasarım & Geliştirme", desc: "Modern, hızlı ve ölçeklenebilir web siteleri ve uygulamaları." },
        { title: "Marka & Kimlik", desc: "Markanızı öne çıkaran görsel dil, logo ve kimlik sistemleri." },
        { title: "SEO & Performans", desc: "Arama motorlarında üst sıralara taşıyan teknik ve içerik optimizasyonu." },
        { title: "Motion & Deneyim", desc: "İz bırakan animasyonlar ve etkileşimli, sinematik kullanıcı deneyimleri." },
      ],
      ctaTitle: "Bir sonraki projeniz Ektiren imzasını taşısın.",
      ctaDesc: "Fikrinizi konuşalım, dijital dünyada fark yaratalım.",
      visit: "ektirenproject.com'u ziyaret et",
    },
  },
  en: {
    nav: { services: "Services", why: "Why Us", fleet: "Fleet", contact: "Contact" },
    hero: {
      overline: "KYRENIA · NORTH CYPRUS · 24/7",
      titleLines: ["VIP GIRNE", "TAKSI"],
      tagline: "Beyond Transportation.",
      desc: "Luxury airport, hotel and casino transfers across Kyrenia and North Cyprus. Discreet, punctual and flawless.",
      cta: "Message on WhatsApp",
      call: "Call Now",
      scroll: "Scroll",
    },
    marquee: ["Kyrenia", "Ercan Airport", "Nicosia", "Famagusta", "Kaya Artemis", "Merit Casino", "Bafra"],
    manifesto: {
      overline: "MANIFESTO",
      title: "Details are everything.",
      chapters: [
        { num: "01", title: "Punctuality", text: "Your chauffeur is waiting the moment you land. We track your flight live and wait for you even on delays. Your time is precious." },
        { num: "02", title: "Discretion", text: "Quiet, reliable and professional chauffeurs. Your journey is private; your comfort and confidentiality are our priority." },
        { num: "03", title: "The Fleet", text: "Immaculate Mercedes VIP vehicles, leather interiors, climate control and space. Every transfer is a first-class experience." },
      ],
    },
    services: {
      overline: "SERVICES",
      title: "Every kind of transfer.",
      items: [
        { tag: "AIRPORT", title: "Ercan Transfer", desc: "Comfortable, punctual VIP transfer from Ercan Airport to your hotel, home or casino." },
        { tag: "CASINO", title: "Casino VIP", desc: "Exclusive VIP transport to Merit, Kaya Artemis and all casino resorts — at your service all night." },
        { tag: "HOTEL", title: "Hotel Transfers", desc: "Door-to-door luxury transfers to every hotel across Kyrenia and North Cyprus." },
      ],
    },
    fleet: {
      overline: "THE FLEET",
      title: "Comfort without limits.",
      desc: "Our modern, immaculate and luxurious fleet delivers first-class comfort on every journey.",
    },
    contact: {
      overline: "CONTACT · OPEN 24/7",
      title: "Your journey is one message away.",
      desc: "Message us on WhatsApp or call for reservations and quotes. We reply instantly.",
      whatsapp: "WhatsApp",
      call: "Call",
    },
    footer: {
      tagline: "Kyrenia / North Cyprus · Luxury Transfer & Transport",
      rights: "All rights reserved.",
      by: "by Ektiren Project",
      aboutEktiren: "About Ektiren Project",
    },
    ektiren: {
      back: "Home",
      overline: "DIGITAL STUDIO",
      title: "Ektiren Project",
      lead: "This website is a product of Ektiren Project. We don't just build websites — we craft digital experiences with character, speed and conversion.",
      body: "Ektiren Project is a digital design and software studio creating luxury, cinematic and performance-driven web experiences. For brands that want to stand apart from their competitors, we build distinctive interfaces, fluid animations and advanced SEO foundations that make a difference. VIP Girne Taksi is a reflection of this approach.",
      services: [
        { title: "Web Design & Development", desc: "Modern, fast and scalable websites and applications." },
        { title: "Brand & Identity", desc: "Visual language, logos and identity systems that elevate your brand." },
        { title: "SEO & Performance", desc: "Technical and content optimization that ranks you higher in search." },
        { title: "Motion & Experience", desc: "Memorable animations and interactive, cinematic user experiences." },
      ],
      ctaTitle: "Let your next project carry the Ektiren signature.",
      ctaDesc: "Let's talk about your idea and make a difference in the digital world.",
      visit: "Visit ektirenproject.com",
    },
  },
};

export const CONTACT = {
  phoneDisplay: "+90 533 865 5571",
  phoneTel: "+905338655571",
  whatsapp: "https://wa.me/905338655571",
  ektiren: "https://ektirenproject.com",
};
